import styled from 'styled-components/macro';
import { COLORS } from 'styleguide';

/* eslint-disable-next-line import/no-cycle */
import EditSnooze from 'admin-editor/containers/EditSnooze';

const FieldWrapper = styled.label`
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin-bottom: 24px;
  padding-bottom: 4px;
  color: #fff;
  font-size: 16px;
  border-bottom: 1px solid ${COLORS.line};

  ${/* sc-selector */EditSnooze} & {
    color: #fff;
    border-color: ${COLORS.gray20};
  }
`;

export default FieldWrapper;
